declare global {
    interface Window {
        __PRERENDER_INJECTED__?: any;

        // which route is currently being prerendered (key)
        __PRERENDER_ROUTE_KEY__?: string;

        // readiness flags for current route
        __PRERENDER_NAV_READY__?: boolean;
        __PRERENDER_CONTENT_READY__?: boolean;

        // prevent double-dispatch
        __PRERENDER_DISPATCHED_FOR__?: string;
    }
}

export function isPrerenderRun(): boolean {
    return typeof window !== 'undefined' && !!window.__PRERENDER_INJECTED__;
}

export function setPrerenderRouteKey(key: string) {
    if (!isPrerenderRun()) return;

    // If route changes, reset flags
    if (window.__PRERENDER_ROUTE_KEY__ !== key) {
        window.__PRERENDER_ROUTE_KEY__ = key;
        window.__PRERENDER_NAV_READY__ = false;
        window.__PRERENDER_CONTENT_READY__ = false;
        window.__PRERENDER_DISPATCHED_FOR__ = undefined;
    }
}

export function markNavReady() {
    if (!isPrerenderRun()) return;
    window.__PRERENDER_NAV_READY__ = true;
}

export function markContentReady() {
    if (!isPrerenderRun()) return;
    window.__PRERENDER_CONTENT_READY__ = true;
}

export function canDispatchForRoute(key: string, needsContent: boolean) {
    if (!isPrerenderRun()) return false;

    const navOk = !!window.__PRERENDER_NAV_READY__;
    const contentOk = needsContent
        ? !!window.__PRERENDER_CONTENT_READY__
        : true;

    return navOk && contentOk && window.__PRERENDER_DISPATCHED_FOR__ !== key;
}

export function markDispatched(key: string) {
    if (!isPrerenderRun()) return;
    window.__PRERENDER_DISPATCHED_FOR__ = key;
}

export function isNavReady() {
    return isPrerenderRun() && !!window.__PRERENDER_NAV_READY__;
}

export function isContentReady() {
    return isPrerenderRun() && !!window.__PRERENDER_CONTENT_READY__;
}
